var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function Share(_a) {
    var { size } = _a, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, Object.assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M16.91 1.508a3.015 3.015 0 0 1-4.57 3.802L6.686 8.574a3.04 3.04 0 0 1 0 .858l5.65 3.262a3.016 3.016 0 1 1-1.003 1.742L5.75 11.213a3.015 3.015 0 1 1 0-4.42l5.583-3.223a3.017 3.017 0 0 1 5.576-2.062zM14.8 3.886a1.005 1.005 0 1 0-1.005-1.74 1.005 1.005 0 0 0 1.005 1.74zm-1.005 11.969a1.005 1.005 0 1 0 1.005-1.74 1.005 1.005 0 0 0-1.005 1.74zm-9.09-6.853a1.005 1.005 0 1 1-2.01 0 1.005 1.005 0 0 1 2.01 0z" }) })));
}
export default Share;
